function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#DFDFDF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(1,0,0,1,-3030.49,-2056.9)"
}, React.createElement("path", {
  className: "st0",
  d: "M3167.4,2056.9h-116c-11.6,0-20.9,9.4-20.9,20.9v116c0,11.6,9.4,20.9,20.9,20.9h116c11.6,0,20.9-9.4,20.9-20.9 v-116C3188.3,2066.3,3179,2056.9,3167.4,2056.9z M3162.6,2067.2h-106.3c-8.5,0-15.4,6.9-15.4,15.4V2189c0,8.5,6.9,15.4,15.4,15.4 h106.3c8.5,0,15.4-6.9,15.4-15.4v-106.3C3178,2074.1,3171.1,2067.2,3162.6,2067.2z"
}));

var SvgCheckerOff = function SvgCheckerOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 157.8 158",
    style: {
      enableBackground: "new 0 0 157.8 158"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckerOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checker-off.bc77dc6d.svg";
export { ForwardRef as ReactComponent };